<template>
  <div>
    <b-table
      id="doctorLabReport"
      ref="doctorLabReport"
      small
      hover
      sort-icon-left
      head-variant="light"
      :items="fileteredLabExpenseList"
      :fields="fields"
      sort-by="creationDt"
      v-model="visibleRows"
      :sort-desc="true"
      :responsive="true"
      show-empty
      sticky-header="calc(100vh - 210px)"
      @row-clicked="onRowClicked"
    >
      <template #cell(index)="row">{{ row.index + 1 }}.</template>
      <template #custom-foot>
        <b-tr variant="secondary" class="text-bold text-right">
          <td class="text-left">รวม</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

          <td>{{ sum("dfAmount") }}</td>
          <td>{{ sum("cfAmount") }}</td>
          <td>{{ sum("price") }}</td>
        </b-tr>
      </template>
      <template #empty="">
        <p class="text-center text-muted my-2">ไม่มีข้อมูลให้แสดง</p>
      </template>
      <template #cell(price)="row">
        <b-tooltip
          :target="'row-' + row.index"
          triggers="manual"
          placement="left"
          customClass="custom-tooltip"
          @shown="onTooltipShown"
          @hidden="onTooltipHidden"
        >
          <LabImageGallery
            v-if="isContainImage"
            cardClass="mb-0"
            photoSize="xs"
            imgStyle="min-width: 100px; height: auto; object-fit: contain"
            category="Invoice"
          />
          <p v-else class="p-3 mb-0">ไม่มีรูป</p>
        </b-tooltip>
        <span :id="'row-' + row.index">{{ row.value }}</span>
      </template>
      <template v-if="hasSubscribed" #table-caption>Click เพื่อดูรูป</template>
    </b-table>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";

import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import moment from "moment";
import LabImageGallery from "@/components/card/Gallery";

import XLSX from "xlsx";

export default {
  name: "doctorLabReport",
  components: {
    Dialog,
    Loading,
    LabImageGallery
  },
  props: ["labReport"],
  data() {
    return {
      isLoading: false,

      fields: [
        {
          key: "index",
          label: ""
        },
        {
          key: "dfDate",
          label: "วันที่คำนวน DF",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate"
        },
        {
          key: "invoiceNo",
          label: "เลขที่ invoice",
          class: "narrow-spacing"
        },
        {
          key: "mLab",
          label: "งานแลป",
          class: "narrow-spacing",
          formatter(i) {
            return i.nameTh;
          }
        },

        {
          key: "mCompanyLab",
          label: "ชื่อบริษัท",
          class: "narrow-spacing",
          formatter(i) {
            return i?.nameTh || "";
          }
        },
        {
          key: "patient",
          label: "ชื่อคนไข้",
          class: "narrow-spacing",
          formatter(i) {
            return i.firstNameTh + " " + i.lastNameTh;
          }
        },
        {
          key: "dfAmount",
          label: "หักแพทย์",
          class: "narrow-spacing text-right"
        },
        {
          key: "cfAmount",
          label: "หักคลินิก",
          class: "narrow-spacing text-right"
        },
        {
          key: "price",
          label: "รวม(บาท)",
          class: "narrow-spacing text-right"
        }
      ],
      visibleRows: [],
      currentImage: null,
      loadingTime: 0,
      tooltipOpen: false,
      mediaFiles: []
    };
  },
  created() {
    this.init();
    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    ...mapGetters({
      hasSubscribed: "moduleBranch/hasSubscribed"
    }),
    fileteredLabExpenseList() {
      return this.labReport;
    },
    isContainImage() {
      return this.mediaFiles.length > 0;
    }
  },
  watch: {},
  methods: {
    ...mapActions({ fecthMediaFiles: "moduleMediaFile/fecthMediaFiles" }),
    init() {},
    moment() {
      return moment();
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    formatTime(date) {
      if (date) {
        return moment(date).locale("th").format("HH:mm");
      } else {
        return "";
      }
    },
    sum(key) {
      let splitStr = key.split(".");
      return this.visibleRows.reduce((accum, item) => {
        let data;
        if (splitStr.length > 1) {
          if (
            item[splitStr[0]] &&
            item[splitStr[0]][splitStr[1]] &&
            item[splitStr[0]][splitStr[1]][splitStr[2]]
          ) {
            data = item[splitStr[0]][splitStr[1]][splitStr[2]];
          } else {
            data = 0;
          }
        } else {
          data = item[key];
        }
        if (typeof data != "number") return null;
        return Math.round((accum + data) * 20) / 20;
      }, 0);
    },
    async onRowClicked(item, index, event) {
      if (this.hasSubscribed) {
        const data = await this.fecthMediaFiles({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          params: { labId: item.id, limit: 100 }
        });
        this.mediaFiles = data;
        await this.$nextTick();

        this.$root.$emit("bv::show::tooltip", "row-" + index);
        return false;
      }
    },
    handleClickOutside(event) {
      if (this.tooltipOpen) {
        const clickedInsideTooltip =
          event.target.closest(".b-tooltip") ||
          event.target.closest('[id^="row-"]');
        if (!clickedInsideTooltip) {
          this.$root.$emit("bv::hide::tooltip");
        }
      }
    },
    onTooltipShown() {
      this.tooltipOpen = true;
    },
    onTooltipHidden() {
      this.tooltipOpen = false;
    }
  },

  mounted() {},
  updated() {},
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style>
.sr-only {
  display: none;
}
.custom-tooltip .tooltip-inner {
  max-width: 300px; /* Adjust as needed */
  padding: 0px;
}
</style>